import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--toggle-inactive"
export default class extends Controller {
  static targets = ["inputTag"];
  connect() {}

  toggle() {
    this.inputTagTargets.forEach((input) => {
      input.classList.toggle("c-form-inactive");
      input.value = "";
    });
  }
}
